import React, { useEffect, useState } from 'react';
import axios from 'axios';
import CardProjet from './cardProjet'; // Importer le composant CardProjet

import { useTranslation } from 'react-i18next';

function ListeProjets() {
  const [projects, setProjects] = useState([]);
  const [filteredProjects, setFilteredProjects] = useState([]);
  const [selectedCategory, setSelectedCategory] = useState('All');
  const [sortOrder, setSortOrder] = useState('asc'); // Tri par date

  const { t, i18n } = useTranslation();

  useEffect(() => {
    // Récupérer les projets avec les catégories de clubs via une jointure
    axios.get('https://www.clublfit.org/api/listeprojets')
      .then(response => {
        const projectsWithImages = response.data.map((project) => {
          let imageUrl;

          if (project.Url_IMG_Projet) {
            imageUrl = project.Url_IMG_Projet;
          } else if (project.Photo_Projet && project.Photo_Projet.data) {
            try {
              const imageBlob = new Blob([Uint8Array.from(project.Photo_Projet.data)], { type: 'image/png' });
              imageUrl = URL.createObjectURL(imageBlob);
            } catch (error) {
              console.error('Erreur lors de la création du blob pour l\'image du projet :', error);
              imageUrl = 'https://via.placeholder.com/850x450'; // Image par défaut en cas d'erreur
            }
          } else {
            imageUrl = 'https://via.placeholder.com/850x450'; // Image par défaut si aucune image n'est disponible
          }

          return { ...project, imageUrl };
        });

        setProjects(projectsWithImages);
        setFilteredProjects(projectsWithImages);
      })
      .catch(error => console.error('Erreur lors de la récupération des projets :', error));
  }, []);

  // Filtrer les projets en fonction des sélections
  useEffect(() => {
    let filtered = projects;

    // Filtrer par catégorie de club sélectionnée
    if (selectedCategory !== 'All') {
      filtered = filtered.filter(project => project.Categorie_Club.toLowerCase() === selectedCategory.toLowerCase());
    }

    // Tri par date de création
    if (sortOrder === 'asc') {
      filtered.sort((a, b) => new Date(a.Date_Creation_Projet) - new Date(b.Date_Creation_Projet));
    } else {
      filtered.sort((a, b) => new Date(b.Date_Creation_Projet) - new Date(a.Date_Creation_Projet));
    }

    setFilteredProjects(filtered);
  }, [selectedCategory, sortOrder, projects]);

  return (
    <div className="container my-5">
      <div className="col-lg-12 col-md-6 mb-30 text-center">
        <h2 className="display-4 mb-4">{t('Liste_des_Projets')}</h2>

        {/* Filtres */}
        <div className="mb-4">
          {/* Filtre par catégorie */}
          <select
            className="form-select w-25 d-inline-block mx-2"
            value={selectedCategory}
            onChange={e => setSelectedCategory(e.target.value)}
          >
            <option value="All">{t('Toutes_les_catégories')}</option>
            {Array.from(new Set(projects.map(project => project.Categorie_Club))).map(category => (
              <option key={category} value={category}>
                {category || 'Non catégorisé'}
              </option>
            ))}
          </select>

          {/* Tri par date de création */}
          <select
            className="form-select w-25 d-inline-block mx-2"
            value={sortOrder}
            onChange={e => setSortOrder(e.target.value)}
          >
            <option value="asc">{t('Date_de_création_croissante')}</option>
            <option value="desc">{t('Date_de_création_decroissante')}</option>
          </select>
        </div>
      </div>

      {/* Grille Bootstrap avec 4 cartes par ligne sur les grands écrans */}
      <div className="row">
        {filteredProjects.map(project => (
          <div className="col-lg-6 col-md-4 col-sm-6 mb-4" key={project.Id_Projet}>
            <div style={{ transform: 'scale(0.9)', transformOrigin: 'top left' }}>
              <CardProjet projects={[project]} />
            </div>
          </div>
        ))}
      </div>

      {/* Si aucun projet n'est trouvé */}
      {filteredProjects.length === 0 && (
        <div className="col-12 text-center">
          <p className="text-muted">{t('Chargement')}</p>
        </div>
      )}
    </div>
  );
}

export default ListeProjets;


